/**
 * Bänder Feature — RTK Query endpoints (queries).
 *
 * Fetches Band definitions + fields for the school.
 * Uses rootApi.injectEndpoints pattern matching settingsApi.
 *
 * @module baende/api/queries
 */

import { rootApi } from "../../../lib/api/rootApi";
import type {
  Band,
  BandExpectedSlot,
  BandLogEntry,
  BandStatisticsLoadResponse,
} from "../types/baendeTypes";

export const baendeQueryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getBaendeForSchool: builder.query<Band[], void>({
      query: () => ({
        type: "rpc",
        rpc: "fn_baende_get_for_school",
      }),
      providesTags: ["Baende" as never],
    }),

    getBandLogEntries: builder.query<
      BandLogEntry[],
      { start_date: string; end_date: string; class_id?: string }
    >({
      query: (arg) => ({
        type: "rpc",
        rpc: "fn_baende_get_log_entries",
        params: {
          p_start_date: arg.start_date,
          p_end_date: arg.end_date,
          p_class_id: arg.class_id || null,
        },
      }),
      providesTags: ["BaendeLogs" as never],
    }),

    getBandExpectedSlots: builder.query<
      BandExpectedSlot[],
      { start_date: string; end_date: string; band_id?: string; class_id?: string }
    >({
      query: (arg) => ({
        type: "rpc",
        rpc: "fn_baende_get_expected_slots",
        params: {
          p_start_date: arg.start_date,
          p_end_date: arg.end_date,
          p_band_id: arg.band_id || null,
          p_class_id: arg.class_id || null,
        },
      }),
      providesTags: ["BaendeLogs" as never],
    }),
    getBandStatisticsData: builder.query<
      BandStatisticsLoadResponse,
      {
        start_date: string;
        end_date: string;
        band_id?: string;
        class_id?: string;
        analyse_field?: string;
      }
    >({
      query: (arg) => ({
        type: "rpc",
        rpc: "fn_baende_get_statistics_data",
        params: {
          p_start_date: arg.start_date,
          p_end_date: arg.end_date,
          p_band_id: arg.band_id || null,
          p_class_id: arg.class_id || null,
          p_analyse_field: arg.analyse_field || null,
        },
      }),
      providesTags: ["BaendeLogs" as never],
    }),
  }),
});

export const {
  useGetBaendeForSchoolQuery,
  useGetBandLogEntriesQuery,
  useGetBandExpectedSlotsQuery,
  useGetBandStatisticsDataQuery,
} = baendeQueryApi;
